/**
 * Klab MMP Report API
 *
 * Contact: jesuspalominomartinez1234@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient,
    HttpContext,
    HttpEvent,
    HttpHeaders,
    HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { KeystrokeReportResponse } from '../model/keystrokeReportResponse';

// @ts-ignore
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface GetEmployeeKeystrokesRequestParams {
    /** The employee database ID. */
    employeeId: number;
    /** Range start date (inclusive, format YYYY-MM-DD). */
    startDate: string;
    /** Range end date (inclusive, format YYYY-MM-DD). */
    endDate: string;
    /** Zero-based page index. */
    page?: number;
    /** Page size. */
    size?: number;
    /** Text filter for app/domain/title/url or typed content. */
    search?: string;
}

@Injectable({
    providedIn: 'root',
})
export class KeystrokeReportsService extends BaseService {
    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string | string[],
        @Optional() configuration?: Configuration,
    ) {
        super(basePath, configuration);
    }

    /**
     * Get employee keystrokes
     * Retrieves paginated keyboard events for an employee within a date range from the MongoDB report projection.
     * @endpoint get /api/v1/report/keystrokes/employee/{employeeId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getEmployeeKeystrokes(
        requestParameters: GetEmployeeKeystrokesRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
    ): Observable<KeystrokeReportResponse>;
    public getEmployeeKeystrokes(
        requestParameters: GetEmployeeKeystrokesRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
    ): Observable<HttpResponse<KeystrokeReportResponse>>;
    public getEmployeeKeystrokes(
        requestParameters: GetEmployeeKeystrokesRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
    ): Observable<HttpEvent<KeystrokeReportResponse>>;
    public getEmployeeKeystrokes(
        requestParameters: GetEmployeeKeystrokesRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
    ): Observable<any> {
        const employeeId = requestParameters?.employeeId;
        if (employeeId === null || employeeId === undefined) {
            throw new Error('Required parameter employeeId was null or undefined when calling getEmployeeKeystrokes.');
        }
        const startDate = requestParameters?.startDate;
        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling getEmployeeKeystrokes.');
        }
        const endDate = requestParameters?.endDate;
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling getEmployeeKeystrokes.');
        }
        const page = requestParameters?.page;
        const size = requestParameters?.size;
        const search = requestParameters?.search;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'startDate',
            <any>startDate,
            QueryParamStyle.Form,
            true,
        );

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'endDate',
            <any>endDate,
            QueryParamStyle.Form,
            true,
        );

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'page',
            <any>page,
            QueryParamStyle.Form,
            true,
        );

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'size',
            <any>size,
            QueryParamStyle.Form,
            true,
        );

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'search',
            <any>search,
            QueryParamStyle.Form,
            true,
        );

        let localVarHeaders = this.defaultHeaders;

        localVarHeaders = this.configuration.addCredentialToHeaders(
            'bearerAuth',
            'Authorization',
            localVarHeaders,
            'Bearer ',
        );

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        const localVarPath =
            `/api/v1/report/keystrokes/employee/${this.configuration.encodeParam({
                name: 'employeeId',
                value: employeeId,
                in: 'path',
                style: 'simple',
                explode: false,
                dataType: 'number',
                dataFormat: 'int64',
            })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<KeystrokeReportResponse>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            params: localVarQueryParameters.toHttpParams(),
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe,
            ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
            reportProgress,
        });
    }
}
